export default __webpack_public_path__ + "static/media/resIcon.8bf4631c.svg";